import { useIntl } from 'react-intl';
import { BrandConfig } from '@sso/brand-configs';
import { Box, socialButtonsExist, Typography } from '@sso/components';
import { formatSubstring, isGermanMarket } from '@sso/core-utils';

import { LegalAgreement } from './LegalAgreement';
import { Configs } from '../types';

type Props = {
  classNames?: string;
  brandConfig: BrandConfig;
  buttonsVisibility: Record<string, boolean>;
  market: string;
  urls: Record<string, string>;
  configs: Configs;
  isResellerMigration: boolean;
  showFactorSelector: boolean;
};

export const LegalDisclaimer = ({
  classNames,
  buttonsVisibility,
  market,
  brandConfig,
  urls,
  configs,
  showFactorSelector,
  isResellerMigration,
}: Props) => {
  const intl = useIntl();
  const socialButtonsPresent = socialButtonsExist(buttonsVisibility);

  return (
    <Box id='create_acct_submit_btn_container' className={classNames} mt='md' mb='md'>
      <Typography
        component='p'
        className='tos-text'
        text={
          <LegalAgreement
            brandConfig={brandConfig}
            isResellerMigration={isResellerMigration}
            urls={urls}
            configs={configs}
            socialButtonsPresent={socialButtonsPresent}
            showFactorSelector={showFactorSelector}
          />
        }
      />
      {isGermanMarket(market) && (
        <Box as='span' id='extra-german-terms-and-conditions' className='tos-text'>
          <br />
          {intl.formatMessage({ id: 'EXTRA_GERMAN_TERMS_AND_CONDITIONS' })}
        </Box>
      )}
      {Boolean(buttonsVisibility.wechat) && (
        <Box id='wechat-tos'>
          <Typography
            component='p'
            className='tos-text'
            text={formatSubstring(intl.formatMessage({ id: 'CLICK_WECHAT_DISCLAIMER' }), {
              0: intl.formatMessage({ id: 'WECHAT' }),
            })}
          />
        </Box>
      )}
    </Box>
  );
};
